<section class="page-header">
  <div class="page-header__details">
    <h2>{{ title }} <img *ngIf="isAdmin" src="assets/svg/icons/admin-access.svg" /></h2>
    <common-breadcrumb></common-breadcrumb>
  </div>
</section>
